import * as React from 'react';

import styles from './styles/WizardSideBar.css';

type IItemsProps = 'route' | 'title';

export interface IWizardSideBarProps {
	items: { [key: string]: { [key in IItemsProps]: string } };
	goToSettingsStep: (step: string) => void;
}

export const WizardSideBar: React.SFC<IWizardSideBarProps> = (props) => {
	const getActiveClass = (step: string) => {
		const pathname = location.hash ? location.hash : location.pathname;
		if (pathname.includes(step)) {
			return styles.activeItem;
		}
		return '';
	};

	const renderItems = () => {
		const sidebarItems = [];
		for (const key in props.items) {
			if (props.items.hasOwnProperty(key)) {
				const activeClass = getActiveClass(props.items[key].route);
				const sidebarItem = (
					<div
						key={props.items[key].title}
						className={`${styles.sidebarItem} ${activeClass}`}
						onClick={() => props.goToSettingsStep(props.items[key].route)}
					>
						{props.items[key].title}
					</div>
				);
				sidebarItems.push(sidebarItem);
			}
		}
		return sidebarItems;
	};

	return (
		<div className={styles.sidebarWrapper}>
			<div className={`${styles.sidebarWrapper} ${styles.sidebar}`}>{props.items && renderItems()}</div>
		</div>
	);
};
